const DISTRIBUTOR_EXTRA_ROLES = [
    'pdv',
];

const state = {
    user: "",
    profile: "",
    permissions: [],
    path: "",
};

const mutations = {
    setUser(state, info) {
        state.user = info;
    },
    setProfile(state, info) {
        state.profile = info
    },
    setPermissions(state, info) {
        state.permissions = info
    },
    clearUser(state) {
        state.user = null;
        state.profile = "";
        state.permissions = [];
        state.path = "";
    },
    setPath(state, path) {
        state.path = path;
    },
};

const actions = {
    initState({ commit }, info) {
        const permissions = info.roles[0].perms.map(permission => permission.name);
        const role = info.roles[0];

        commit('setUser', info);
        commit('setProfile', role);
        commit('setPermissions', permissions);
    },
    updateUser({ commit }, info) {
        commit('setUser', info);
    },
    updateProfile({ commit }, info) {
        commit('setProfile', info)
    },
    updatePermissions({ commit }, info) {
        commit('setPermissions', info)
    },
    logout({ commit }) {
        commit('clearUser');
    },
    updatePath({ commit }, path) {
        commit('setPath', path);
    },
};

const getters = {
    getUser: state => state.user,
    getProfile: state => state.profile,
    getPermissions: state => state.permissions,
    isAuthenticated(state) {
        return !!state.user;
    },
    isDistribuidor(state) {
        return state.user.distribuidor ? true : false;
    },
    isAnalyst(state) {        
        return state.profile.name === 'adm' || state.profile.name === 'coord_comercial';
    },
    getUser(state) {
        return state.user;
    },
    getPath(state) {
        return state.path;
    },
    getUserId(state) {
        return state.user.id;
    },
    /** Verifica se o usuario logado possui determinada funcao */
    isAnyRole: state => (roles) => {
        const userRoles = state.user.roles;

        if (!userRoles) {
            return false;
        }

        // Garante que sempre trabalharemos com arrays
        const expectedRoles = Array.isArray(roles) ? roles : [roles];
        const currentRoles = Array.isArray(userRoles) ? userRoles : [userRoles];

        return currentRoles.some(userRole =>
            expectedRoles.some(role =>
                (userRole.name || '').toLowerCase() === role.toLowerCase()
            )
        );
    },
    /** Verifica se o usuario logado possui determinada permissao */
    hasAnyPermission: state => (permissions) => {
        const userPermissions = state.permissions;

        if (!userPermissions || !userPermissions.length) {
            return false;
        }

        // Garante que sempre trabalharemos com arrays
        const expectedPermissions = Array.isArray(permissions) ? permissions : [permissions];

        const currentPermissions = userPermissions.map(permission =>
            (permission || '').toLowerCase()
        );

        return expectedPermissions.some(permission =>
            currentPermissions.includes((permission || '').toLowerCase())
        );
    },
    isDistributor: state => () => {
        const userRoles = state.user.roles;

        if (!userRoles) {
            return false;
        }

        const currentRoles = Array.isArray(userRoles) ? userRoles : [userRoles];

        return currentRoles.some(userRole => {
            const roleName = (userRole.name || '').toLowerCase();

            return roleName.startsWith('distribuidor_')
                || DISTRIBUTOR_EXTRA_ROLES.includes(roleName);
        });
    },
    getDistributor: state => () => {
        const userHaveDistributor = state?.user?.distribuidor
            ? state.user.distribuidor
            : null;

        return userHaveDistributor;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/user.js